/// <reference path="../_all.ts" />

module library {
  'use strict';


  export function ByDocumentFilter() {

     return function(obj : any[], doc : Document, property : string) { //items, search
       obj = obj || [];
       var out = [];

       obj.forEach((o : any) => {
         doc.Revisions.forEach((rev: DocumentRev) => {
           if (o[property] == rev[property]) {
             out.push(o);
           }
         });         
       });
       return out;
     }
  }
}